import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import AuthContainer from "../../../components/AuthContainer.js";
import appcolors from "../../../constants/Colors.js";
import LoginForm from "./LoginForm.js";
import { allIcons } from "../../../assets/index.js";

const Login = () => {
  return (
    <AuthContainer>
      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <Typography
          variant="body2"
          fontFamily={"Inter"}
          color={appcolors.slateGrey}
        >
          Create your account?
        </Typography>
        <Link
          to={"/sign-up"}
          className="react-router-link"
          style={{
            fontWeight: 700,
            color: appcolors.primary,
          }}
        >
          Sign up
        </Link>
      </Stack>

      <Container sx={{ maxWidth: "520px !important", mt: 6 }}>
        <Typography variant="auth_h1" component={"h1"}>
          Login
        </Typography>
        <Typography variant="auth_body1" component={"p"} sx={{ mt: 0.5 }}>
          Welcome to{" "}
          <span style={{ color: appcolors.black, fontWeight: "bold" }}>
            LOBA
          </span>{" "}
          CRM, Please give us user id and password
        </Typography>
        <LoginForm />
        {/* <Stack
          m={"14px 0"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Divider sx={{ width: "40%" }} />
          <Typography variant="body1" color={appcolors.darkGrey}>
            OR
          </Typography>
          <Divider sx={{ width: "40%" }} />
        </Stack>
        <Typography variant="auth_body1" component={"p"}>
          Continue With Accountts
        </Typography>
        <Stack
          gap={2}
          mt={1}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box className={"social-icons-container"}>
            <img src={allIcons.googleIcon} alt="google-icon" width={25} />
          </Box>
          <Box className={"social-icons-container"}>
            <img src={allIcons.linkedinIcon} alt="google-icon" width={25} />
          </Box>
        </Stack> */}
      </Container>
    </AuthContainer>
  );
};

export default Login;
